module.exports = __webpack_public_path__ + "static/img/nakazawa_03.5ad4f6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/nakazawa_03.png
// module id = Er85
// module chunks = 0